function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.03 12a.941.941 0 01-.726-.298l-.639-.67a1.03 1.03 0 01-.111-.139L2.29 6.443a1.08 1.08 0 010-1.475l.638-.67a.934.934 0 011.367-.001L8 8.165l3.704-3.867a.934.934 0 011.367 0l.639.67a1.08 1.08 0 01-.001 1.475l-4.266 4.455a1.028 1.028 0 01-.108.134l-.64.67a.944.944 0 01-.665.297z",
  fill: "currentColor"
})));